var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 50,
    viewBox: "0 0 37 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.968 18.8354L26.3013 17.1354V6.46875H10.168V17.2354L12.4013 18.8354C13.668 17.0021 15.8013 15.8021 18.2013 15.8021C20.6013 15.8021 22.7013 17.0021 23.968 18.8354Z",
    fill: "#E60000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.7333L18.1667 23.0333L21.4 20.7C20.7 19.6667 19.5333 19 18.2 19C16.8667 19.0333 15.6667 19.7 15 20.7333Z",
    fill: "#E60000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93438 6.26668C6.93438 4.56667 8.30105 3.2 10.001 3.2H26.4344C28.1344 3.2 29.5011 4.56667 29.5011 6.26668V14.8334L32.7011 12.5333V6.26668C32.7011 6.23334 32.7011 6.23334 32.7011 6.20001V3.13334V0.233335V0H26.5011H26.4677H10.0344H10.001H3.73438V0.233335V3.13334V6.20001C3.73438 6.23334 3.73438 6.23334 3.73438 6.26668V12.5333L6.93438 14.8667V6.26668Z",
    fill: "#E60000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.7656V35.599L18.2334 49.999L36.4667 35.599V13.7656C30.3667 18.1656 24.2667 22.5656 18.1667 26.9656C12.1 22.5656 6.03334 18.1656 0 13.7656Z",
    fill: "#E60000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupLogo);
export default __webpack_public_path__ + "static/media/GroupLogo.f47829b6640291dd84d0228bcc7d100a.svg";
export { ForwardRef as ReactComponent };